import './sass/style.scss';
import './js/app.js';
import $ from 'jquery';
import Swiper from 'swiper';
import { Navigation, Autoplay, Pagination, Parallax } from 'swiper/modules';
import 'swiper/swiper-bundle.css';
import * as woocommerce0 from '../views/woocommerce/archive-product/archive-product.js'; import * as woocommerce1 from '../views/woocommerce/components/AddedToCartPopup/added-to-cart-popup.js'; import * as woocommerce2 from '../views/woocommerce/components/ProductGallery/product-gallery.js'; import * as woocommerce3 from '../views/woocommerce/components/SidebarCart/sidebar-cart.js'; let woocommerce = [woocommerce0, woocommerce1, woocommerce2, woocommerce3];

const target = document.querySelector('.variations_form');

if (target) {
    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.attributeName === 'class') {
                const element = mutation.target;
                if (
                    element.classList.contains('selected') ||
                    element.classList.contains('wapf-checked')
                ) {
                    const value = $(
                        `select[data-attribute_name="attribute_pa_powierzchnia-spania"]`,
                    ).val();

                    const relatedElements = $(`[data-wapf-label="${value}"]:not(:disabled)`);

                    relatedElements.each(function (index, el) {
                        const item = $(el).closest('.wapf-swatch.has-pricing');
                        if (!item.hasClass('wapf-checked')) {
                            item.click();
                        }
                    });
                }
            }
        });
    });

    const config = { attributes: true, childList: true, subtree: true };
    observer.observe(target, config);
}

let scrollTimeout;

$('.field-67daef5cfb4c0, .field-67ea83e35816d, .field-68d1583f6df1e').on(
    'click',
    '.wapf-swatch--image',
    function () {
        if (scrollTimeout) {
            clearTimeout(scrollTimeout);
        }

        scrollTimeout = setTimeout(() => {
            const target = $('.material-color:not(.wapf-hide)').first();

            if (target.length) {
                $('html, body').animate({
                    scrollTop: target.offset().top - 107,
                });
            }
        }, 200);
    },
);

document.querySelector('form.cart')?.addEventListener('submit', function () {
    const customQty = document.getElementById('custom-quantity-input').value;
    document.querySelector('form.cart .quantity input.qty').value = customQty;
});

function initSwiper() {
    if (document.getElementById('hero-static')) {
        document.getElementById('hero-static').style.display = 'none';
    }
    if (document.getElementById('hero-slider')) {
        document.getElementById('hero-slider').style.display = 'block';
    }
    const homepageMainSlider = new Swiper('.homepage-main-slider', {
        loop: true,
        speed: 800,
        modules: [Navigation, Pagination, Autoplay, Parallax],
        parallax: {
            enabled: true,
        },
        navigation: {
            nextEl: '.homepage-main-slider-right',
            prevEl: '.homepage-main-slider-left',
        },
        pagination: {
            el: '.homepage-main-slider-pagination',
            clickable: true,
        },
        autoplay: {
            delay: 5000,
        },
    });
}

$(window).on('load', initSwiper);
